exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select{height:40px}.v-select-small.v-select{height:30px}.vs__dropdown-toggle{height:100%}.v-select.vs--disabled{background-color:#f1f1f1;cursor:default}.v-select .vs__selected{height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.select-actions{padding-top:0;padding-bottom:3px}.open-indicator{height:100%;padding-top:10px}", ""]);

// exports
